/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { block } from "@api/Api";
import { data } from "jquery";

export const getBlackList = createAsyncThunk(
  "BlackList/getBlackList",
  async (values) => {
    try {
      return block.getBlackList(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addBlackList = createAsyncThunk(
  "appBlackList/addBlackList",
  async (values) => {
    try {
      return block.addBlackList(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const editBlock = createAsyncThunk(
  "appBlock/editBlock",
  async (values) => {
    return block.editBlock(values);
  }
);

export const appLabelsSlice = createSlice({
  name: "appLabels",
  initialState: {
    blackList: [],
    blackListFetch: false,
    metaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBlackList.fulfilled, (state, action) => {
      if (action.payload.status !== 200) {
        state.blackList = [];
        state.blackListFetch = false;
        state.metaData = {};
        return;
      }
      state.metaData = action.payload?.data?.metaData;
      state.blackList = action.payload?.data?.data || [];
      state.blackListFetch = true;
    });
  },
});

export default appLabelsSlice.reducer;
